import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import { Card, CardBody } from "reactstrap";
import styled from "styled-components";
import "./index.css";

import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Drawer,
  Form,
  Input,
  InputNumber,
  Modal,
  Popover,
  Row,
  Select,
  Space,
  Table,
  Tag,
  Upload,
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import moment from "moment";
import { PlusCircle } from "react-feather";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  BudgetApi,
  BulkUploadItemApi,
  BulkUploadSubItemApi,
  OrganisationcategoryApi,
  ProjectMemberApi,
  SubItemApi,
} from "../../../../api";
import {
  deleteBudgetItems,
  fetchItemPoDetails,
} from "../../../../api/item.api";
import { downloadPoBudgetData } from "../../../../api/organisation.api";
import { LogEvents, LoggerContext } from "../../../../context/logging";
import { getTableHeight } from "../../../../utils/TableHelpers/TableHeightHelper";
import ColumnConfig from "./column-config";
import UploadResultTable from "./uploadResultTable";
import { getFormattedDate } from "../../../../utils/DateFunctions/dateFormatter";

const ContainerUpload = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-width: 2px;
  border-radius: 2px;
  border-color: #e8e8e8;
  border-style: dashed;
  background-color: #fafafa;
  color: #bdbdbd;
  outline: none;
  transition: border 0.24s ease-in-out;
`;

export function StyledDropzone(props) {
  const {
    acceptedFiles,
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone();
  useEffect(() => {
    if (acceptedFiles.length > 0) props.setFile(acceptedFiles[0]);
  }, [acceptedFiles]);
  const files = acceptedFiles.map((file) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));
  return (
    <div className="container">
      <ContainerUpload
        {...getRootProps({ isDragActive, isDragAccept, isDragReject })}
      >
        <input {...getInputProps()} />
        <div style={{ height: 120 }}>
          <p style={{ marginTop: 40, textAlign: "center" }}>
            Bulk Upload files.
            <br /> Drag and drop your file here, or click to select.
          </p>
        </div>
      </ContainerUpload>
    </div>
  );
}

const { Option } = Select;
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});

// import SearchFilter from "./searchFilter";
const Budget = (props) => {
  const { Search } = Input;
  const logger = React.useContext(LoggerContext);
  const location = useLocation();

  const subItemCompRef = useRef();
  const { dispatch } = props;
  const history = useNavigate();
  const [poDetailsDrawerVisible, setPoDetailsDrawerVisible] = useState(false);
  const [itemList, setItemList] = useState([]);
  const [poDetailsOfItem, setPoDetailsOfItem] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [itemAssignedTo, setItemAssignedTo] = useState(null);
  const [date, setDate] = useState(new Date());
  const [visibleSub, setVisibleSub] = useState(false);
  const [editId, setEditId] = useState(null);
  const [itemId, setItemId] = useState(null);
  const [editIdSub, setEditIdSub] = useState(null);
  const [modal1Visible, setModal1Visible] = useState(false);
  const [modal2Visible, setModal2Visible] = useState(false);
  const [modal3Visible, setModal3Visible] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedItemsForDelete, setSelectedItemsForDelete] = useState([]);
  const [selectedSubItemsForDelete, setSelectedSubItemsForDelete] = useState(
    []
  );
  const [projectMembers, setProjectMembers] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRowKeysItems, setSelectedRowKeysItems] = useState([]);
  const [selectedRowKeysSubItems, setSelectedRowKeysSubItems] = useState([]);
  const [currentVisibleIds, setCurrentVisibleIds] = useState([]);
  const [currentVisibleSubItemIds, setCurrentVisibleSubItemIds] = useState([]);
  const [selectedSubItems, setSelectedSubItems] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const [categories, setcategories] = useState([]);
  const subItemRef = useRef();

  const columns = [
    {
      title: "S.no",
      key: "s_no",
      dataIndex: "s_no",
      width: 100,
    },
    {
      title: "BOQ Item",
      key: "boq_item",
      ellipsis: true,
      dataIndex: "boq_item",
      width: 200,
    },
    {
      title: "Brand",
      key: "brand",
      ellipsis: true,
      dataIndex: "brand",
      width: 200,
    },
    {
      title: "Category",
      key: "category_name",
      ellipsis: true,
      // filters: props.settings?.categories?.map((category) => {
      //   return {
      //     ...category,
      //     text: category?.category_name,
      //     value: category?.id,
      //   };
      // }),
      // filterSearch: true,
      // onFilter: (value, record) => record.category_name == value,
      render: (data) => (
        <span>
          {
            props.settings?.categories?.filter(
              (each) => each.id === data.category_name
            )[0]?.category_name
          }
        </span>
      ),
      width: 150,
    },
    {
      title: "Item Description",
      key: "item_description",
      dataIndex: "item_description",
      ellipsis: {
        showTitle: false,
      },
      render: (item_description) => (
        <Popover
          placement="topLeft"
          title={"Item Description"}
          content={item_description}
        >
          {item_description}
        </Popover>
      ),
      width: 200,
    },
    {
      title: "Quantity",
      key: "quantity",
      ellipsis: true,
      dataIndex: "quantity",
      width: 140,
    },
    {
      title: "Quotation Num.",
      key: "identifier",
      ellipsis: true,
      dataIndex: "identifier",
      width: 140,
    },
    {
      title: "PO Quantity",
      key: "po_quantity",
      ellipsis: true,
      width: 140,
      render: (data) => (
        <span>
          {parseFloat(data.avg_po_price?.total_po_quantity ?? 0).toFixed(2)}
        </span>
      ),
    },
    {
      title: "Unit",
      key: "unit",
      ellipsis: true,
      dataIndex: "unit",
      width: 120,
    },
    {
      title: "Sales Price",
      key: "boq_price",
      ellipsis: true,
      dataIndex: "boq_price",
      width: 100,
    },
    {
      title: "Target Price",
      key: "budget_price",
      ellipsis: true,
      dataIndex: "budget_price",
      width: 100,
    },
    {
      title: "PO Price",
      key: "po_price",
      width: 150,
      render: (data) => (
        <span>
          {parseFloat(
            (data.avg_po_price?.total_po_price ?? 0) /
              (data.avg_po_price?.total_po_quantity ?? 1)
          ).toFixed(2)}
        </span>
      ),
    },
    {
      title: "Pending Budget",
      key: "pending_budget",
      width: 150,
      render: (data) => (
        <span>
          {parseFloat(
            (data.budget_price ?? 0) * (data.quantity ?? 0) -
              (data.avg_po_price?.total_po_price ?? 0)
          ).toFixed(2)}
        </span>
      ),
    },
    {
      title: "Sales Amount",
      key: "sales_amount",
      width: 150,
      render: (data) => (
        <span>
          {parseFloat((data.boq_price ?? 0) * (data.quantity ?? 0)).toFixed(2)}
        </span>
      ),
    },
    {
      title: "Target Amount",
      key: "target_amount",
      width: 150,
      render: (data) => (
        <span>
          {parseFloat((data.budget_price ?? 0) * (data.quantity ?? 0))?.toFixed(
            2
          )}
        </span>
      ),
    },
    {
      title: "PO Amount(Without Tax)",
      key: "po_amount",
      width: 150,
      render: (data) => (
        <span>
          {parseFloat(data.avg_po_price?.total_po_price ?? 0).toFixed(2)}
        </span>
      ),
    },
    {
      title: "Absolute Margin",
      key: "absolute_margin",
      render: (data) => (
        <span>
          {/* {(
            ((data.boq_price ?? 0) - (data.budget_price ?? 0)) *
            (data?.quantity ?? 0)
          )?.toFixed(2)} */}

          {(
            parseFloat((data.boq_price ?? 0) * (data.quantity ?? 0)).toFixed(
              2
            ) -
            (data.avg_po_price?.total_po_price
              ? parseFloat(data.avg_po_price?.total_po_price ?? 0).toFixed(2)
              : parseFloat(
                  (data.budget_price ?? 0) * (data.quantity ?? 0)
                ).toFixed(2))
          ).toFixed(2)}
        </span>
      ),
      width: 150,
    },
    {
      title: "Gross Margin",
      key: "gross_margin",
      render: (data) => (
        <span>
          {/* {((data.boq_price - data.budget_price) / data.boq_price == 0
            ? 1
            : ((data.boq_price - data.budget_price) / data.boq_price) * 100
          ).toFixed(2)} */}
          {(
            (parseFloat((data.boq_price ?? 0) * (data.quantity ?? 0)).toFixed(
              2
            ) -
              (data.avg_po_price?.total_po_price
                ? parseFloat(data.avg_po_price?.total_po_price ?? 0).toFixed(2)
                : parseFloat(
                    (data.budget_price ?? 0) * (data.quantity ?? 0)
                  )?.toFixed(2))) /
            parseFloat((data.boq_price ?? 1) * (data.quantity ?? 1)).toFixed(2)
          )?.toFixed(2) * 100}
          %
        </span>
      ),
      width: 150,
    },
    {
      title: "Timeline",
      key: "timeline",
      render: (data) => (
        <span>{data?.timeline ? getFormattedDate(data?.timeline) : "NA"}</span>
      ),
      width: 150,
    },
    // {
    //   title: "Tax type",
    //   key: "tax_type",
    //   render: (data) => (
    //     <span>
    //       {taxTypes.filter((each) => each.value === data?.tax_type)[0]?.label}
    //     </span>
    //   ),
    //   width: 150,
    //   selected: false,
    // },
    // {
    //   title: "Tax value",
    //   key: "tax_value",
    //   width: 150,
    //   render: (data) => <span>{data?.tax_value}%</span>,
    //   selected: false,
    // },
    {
      title: "Actions",
      key: "action",
      width: 600,
      render: (data) => (
        <Space>
          {data?.sub_items && (
            <>
              {data?.is_po_raised && (
                <Tag
                  onClick={() => {
                    logger.log(LogEvents.seeItemPoDetails, {});
                    setPoDetailsDrawerVisible(true);
                    fetchItemPoDetails({ item_id: data?.id }).then((res) => {
                      // history(
                      //   "/app/project/po-details/" + res[res?.length - 1]?.po
                      // );
                      setPoDetailsOfItem(res);
                    });
                  }}
                  color={"#2db7f5"}
                  style={{ cursor: "pointer" }}
                >
                  See Po Details
                </Tag>
              )}
              <Tag
                onClick={() => {
                  showDrawerSub();
                  setItemId(data.id);
                  logger.log(LogEvents.addSubItem, {});
                }}
                icon={<PlusOutlined />}
                color={"purple"}
              >
                Add Sub Item
              </Tag>
            </>
          )}
          <Tag
            onClick={() => {
              if (data?.sub_items) {
                setItemAssignedTo(data?.assigned_to);
                setDate(data.timeline);
                onUpdate(data.id);
              } else {
                setItemAssignedTo(data?.assigned_to);
                setDate(data.timeline);
                onUpdateSub(data?.id);
              }
            }}
            icon={<EditOutlined />}
            color={"warning"}
          >
            Edit Details
          </Tag>
        </Space>
      ),
    },
  ];
  const [leftOutSelectedRowsItems, setLeftOutSelectedRowsItems] = useState([]);
  const [leftOutSelectedRowsSubItems, setLeftOutSelectedRowsSubItems] =
    useState([]);
  const [leftOutSelectedItems, setLeftOutSelectedItems] = useState([]);
  const [leftOutSelectedSubItems, setLeftOutSelectedSubItems] = useState([]);
  const [userSelectedColumns, setUserSelectedColumns] = useState(columns);

  const showDrawer = () => {
    setVisible(true);
  };
  const { Dragger } = Upload;
  const showDrawerSub = () => {
    setVisibleSub(true);
  };

  const fetchcategories = () => {
    axios.get(`${OrganisationcategoryApi}`).then((res) => {
      setcategories(res.data);
    });
  };
  const formRef = useRef();
  const onClose = () => {
    setEditId(null);
    formRef.current.resetFields();
    setVisible(false);
  };
  const onCloseSub = () => {
    setEditIdSub(null);
    if (subItemRef) {
      subItemRef?.current?.resetFields();
    }
    setVisibleSub(false);
  };
  const handleDownload = async () => {
    downloadPoBudgetData({ project: props.settings?.project?.id });
  };
  const fetchItems = (params = {}) => {
    const {
      settings: { project },
    } = props;
    setLoading(true);
    axios
      .get(`${BudgetApi}`, { params: { ...params } })
      .then((res) => {
        let visibleSubItemIds = [];
        let items = res.data?.map((item) => {
          const children = item?.sub_items?.map((sub_item) => {
            visibleSubItemIds.push(sub_item?.id);
            return {
              ...sub_item,
              boq_item: sub_item.boq_sub_item,
              category_name: sub_item?.category_name_id,
            };
          });
          if (children?.length > 0) {
            return {
              ...item,
              children: children,
            };
          }
          return { ...item };
        });
        if (location?.state?.item_id) {
          items = items.sort(function (x, y) {
            return x.id == location.state.item_id
              ? -1
              : y.id == location.state.item_id
              ? 1
              : 0;
          });
        }
        const visibleIds = items?.map((item) => item.id);
        setItemList(items);
        setCurrentVisibleIds(visibleIds);
        setCurrentVisibleSubItemIds(visibleSubItemIds);
        setLoading(false);
      })
      .catch((error) => {
        console.log("error", { error });
        toast.error("Something went wrong!");
      });
  };

  const AddItem = () => {
    logger.log(LogEvents.submitBoqItem, {});

    const updatedValues = formRef.current.getFieldsValue();
    const {
      settings: { project },
    } = props;
    const values = new FormData();
    values.append("project", project.id);
    values.append("boq_item", updatedValues.boq_item);
    values.append(
      "category_name",
      updatedValues.category_name ? updatedValues.category_name : ""
    );
    values.append(
      "item_description",
      updatedValues.item_description ? updatedValues.item_description : ""
    );
    values.append("unit", updatedValues.unit ? updatedValues.unit : "");
    values.append("quantity", updatedValues.quantity);
    values.append("brand", updatedValues.brand ? updatedValues.brand : "");
    values.append("budget_price", updatedValues.budget_price);
    values.append("boq_price", updatedValues.boq_price);
    values.append(
      "timeline",
      moment(date)?.format("YYYY-MM-DD") ??
        moment(updatedValues?.timeline)?.format("YYYY-MM-DD") ??
        moment()?.format("YYYY-MM-DD")
    );
    if (itemAssignedTo) {
      values.append("assigned_to", itemAssignedTo);
    }
    values.append(
      "tax_type",
      updatedValues.tax_type ? updatedValues.tax_type : "none"
    );
    values.append(
      "tax_value",
      updatedValues.tax_value ? updatedValues.tax_value : ""
    );
    values.append("remark", updatedValues.remark ? updatedValues.remark : "");
    if (editId) {
      axios
        .put(`${BudgetApi}${editId}/`, values)
        .then((res) => {
          toast.success("Item Edited Successfully!");
          onClose();
          fetchItems({ project: props.settings?.project?.id });
        })
        .catch((res) => {
          toast.error("Something went wrong!");
          fetchItems({ project: props.settings?.project?.id });
        });
    } else {
      axios
        .post(`${BudgetApi}`, values)
        .then((res) => {
          toast.success("Item Added Successfully!");
          onClose();
          fetchItems({ project: props.settings?.project?.id });
        })
        .catch((res) => {
          toast.error("Something went wrong!");
          fetchItems({ project: props.settings?.project?.id });
        });
    }
  };
  const onUpdate = (id) => {
    logger.log(LogEvents.editDetailsBudget, {});
    setEditId(id);
    setVisible(true);
    axios.get(`${BudgetApi}${id}/`).then((res) => {
      formRef.current.setFieldsValue({
        boq_item: res.data.boq_item,
        category_name: props.settings?.categories?.filter(
          (each) => each.id === res.data.category_name
        )[0]?.category_name,
        assigned_to: res.data.assigned_to,
        item_description: res.data.item_description,
        unit: res.data.unit,
        timeline: res?.data?.timeline,
        quantity: res.data.quantity,
        brand: res.data.brand,
        budget_price: res.data.budget_price,
        boq_price: res.data.boq_price,
        tax_value: res.data.tax_value,
        tax_type: res.data.tax_type,
        remark: res.data.remark,
      });
    });
  };
  const onUpdateSub = (id) => {
    logger.log(LogEvents.editDetailsBudget, {});
    setEditIdSub(id);

    setVisibleSub(true);
    axios.get(`${SubItemApi}${id}/`).then((res) => {
      subItemRef.current.setFieldsValue({
        boq_sub_item: res.data.boq_sub_item,
        assigned_to: res.data.assigned_to,
        timeline: res?.data?.timeline,
        boq_price: res.data.boq_price,
        category_name: props.settings?.categories?.filter(
          (each) => each.id === res.data.category_name
        )[0]?.category_name,
        item_description: res.data.item_description,
        unit: res.data.unit,
        quantity: res.data.quantity,
        brand: res.data.brand,
        budget_price: res.data.budget_price,
        tax_value: res.data.tax_value,
        tax_type: res.data.tax_type,
      });
      setItemId(res.data.item);
    });
  };
  const taxTypes = [
    {
      id: 1,
      label: "None",
      value: "none",
    },
    {
      id: 2,
      label: "CGST/SGST",
      value: "cgst_sgst",
    },
    {
      id: 4,
      label: "IGST",
      value: "igst",
    },
  ];
  const AddSubItem = () => {
    const updatedValues = subItemRef.current.getFieldsValue();
    const values = new FormData();
    if (itemId) values.append("item", itemId);
    values.append("boq_sub_item", updatedValues.boq_sub_item ?? "");
    values.append("boq_price", updatedValues.boq_price ?? 0);
    values.append(
      "category_name",
      updatedValues.category_name ? updatedValues.category_name : ""
    );
    values.append(
      "item_description",
      updatedValues.item_description ? updatedValues.item_description : ""
    );
    values.append("unit", updatedValues.unit ? updatedValues.unit : "");
    values.append("quantity", updatedValues.quantity);
    values.append("brand", updatedValues.brand ? updatedValues.brand : "");
    values.append("budget_price", updatedValues.budget_price ?? 0);
    values.append(
      "tax_type",
      updatedValues.tax_type ? updatedValues.tax_type : "none"
    );
    if (itemAssignedTo) {
      values.append("assigned_to", itemAssignedTo);
    }
    values.append(
      "tax_value",
      updatedValues.tax_value ? updatedValues.tax_value : 0
    );
    if (editIdSub) {
      axios
        .put(`${SubItemApi}${editIdSub}/`, values)
        .then((res) => {
          toast.success("Sub Item Edited Successfully!");
          onCloseSub();
          fetchItems({ project: props.settings?.project?.id });
        })
        .catch((e) => {
          toast.error("Something went wrong!");
          fetchItems({ project: props.settings?.project?.id });
        });
    } else {
      axios
        .post(`${SubItemApi}`, values)
        .then((res) => {
          toast.success("Sub Item Added Successfully!");
          onCloseSub();
          fetchItems({ project: props.settings?.project?.id });
        })
        .catch((e) => {
          toast.error("Something went wrong!");
          fetchItems({ project: props.settings?.project?.id });
        });
    }
  };

  useEffect(() => {
    logger.log(LogEvents.projectBudget, {});
    fetchcategories();
    fetchItems({ project: props.settings?.project?.id });
    fetchMembers({ project: props.settings.project.id });
  }, []);

  const fetchMembers = (params = {}) => {
    axios.get(`${ProjectMemberApi}`, { params: { ...params } }).then((res) => {
      const arr = res?.data?.map((member) => {
        if (member)
          return {
            ...member,
            value: member.id,
            label: member?.user_organisation?.user?.name,
          };
      });
      setProjectMembers(arr);
    });
  };

  const getUserSelectedColumns = () => {
    return userSelectedColumns
      .filter((column) => {
        return column?.selected !== false;
      })
      .map((column) => {
        return columns.find((col) => col.key === column.key);
      });
  };
  useEffect(() => {
    const leftOutRowsItems = selectedRowKeysItems.filter(
      (el) => !currentVisibleIds.includes(el)
    );
    const leftOutSelectedItems = selectedItems.filter(
      (el) => !currentVisibleIds.includes(el.id)
    );

    const leftOutRowsSubItems = selectedRowKeysSubItems.filter(
      (el) => !currentVisibleSubItemIds.includes(el)
    );
    const leftOutSelectedSubItems = selectedSubItems.filter(
      (el) => !currentVisibleSubItemIds.includes(el.id)
    );

    setLeftOutSelectedRowsItems(leftOutRowsItems);
    setLeftOutSelectedItems(leftOutSelectedItems);
    setLeftOutSelectedRowsSubItems(leftOutRowsSubItems);
    setLeftOutSelectedSubItems(leftOutSelectedSubItems);
  }, [currentVisibleIds, currentVisibleSubItemIds]);

  useEffect(() => {
    if (props.settings?.user?.user_selected_columns?.budget_table) {
      const columnSettings = userSelectedColumns?.map((col) => {
        let currentCol =
          props.settings?.user?.user_selected_columns?.budget_table?.find(
            (column) => col.key == column?.key
          );
        let selected = true;
        if (
          (currentCol?.key === "tax_value" && currentCol?.selected !== true) ||
          (currentCol?.key === "tax_type" && currentCol?.selected !== true)
        ) {
          selected = false;
        } else {
          selected = currentCol?.selected ?? true;
        }
        return { ...col, selected: selected };
      });
      setUserSelectedColumns(columnSettings);
    }
  }, [props.settings?.user?.user_selected_columns?.budget_table]);

  const onSelectChange = (record, selected, selectedRows) => {
    console.log("record", record, selected, selectedRows);

    // setSelectedRowKeys(record);
    let items = selected?.filter((item) => item?.sub_items);
    let sub_items = selected?.filter((sub_item) => !sub_item?.sub_items);
    let sub_items_selected = sub_items?.map((sub_item) => {
      return {
        ...sub_item,
        unit_po_price: sub_item?.budget_price,
        discount: 0,
      };
    });
    let items_selected = items?.map((item) => {
      return {
        ...item,
        unit_po_price: item?.budget_price,
        discount: 0,
      };
    });
    items_selected = items_selected.map((item) => {
      delete item.children;
      delete item.sub_items;
      return item;
    });
    // setSelectedSubItems(sub_items?.map((sub_item) => sub_item?.id));
    setSelectedSubItems([...sub_items_selected, leftOutSelectedSubItems]);
    setSelectedItems([...items_selected, ...leftOutSelectedItems]);
    const itemIds = items_selected?.map((item) => item.id);
    const subItemIds = sub_items_selected?.map((item) => item.id);
    setSelectedItemsForDelete([...itemIds, ...leftOutSelectedRowsItems]);
    setSelectedSubItemsForDelete([
      ...subItemIds,
      ...leftOutSelectedRowsSubItems,
    ]);
    setSelectedRowKeys([
      ...itemIds,
      ...subItemIds,
      ...leftOutSelectedRowsItems,
      ...leftOutSelectedRowsSubItems,
    ]);
    setSelectedRowKeysItems([...itemIds, ...leftOutSelectedRowsItems]);
    setSelectedRowKeysSubItems([...subItemIds, ...leftOutSelectedRowsSubItems]);
    // setSelectedItems(items?.map((item) => item?.id));
    console.log("changesd", itemIds, subItemIds);
  };
  const rowSelection = {
    selectedRowKeys,
    selectedItems,
    onChange: onSelectChange,
  };

  const onSearch = (value) => {
    logger.log(LogEvents.searchBudgetItem, {});
    fetchItems({ project: props.settings?.project?.id, search: value });
  };

  const createPoWithSelectedItems = () => {
    logger.log(LogEvents.createPoWoFromBudgetTable, {});
    let project_selected_items =
      props.settings.selected_budget_items?.project_selected_items;
    const selectedItemsForRedux = selectedItems?.concat(selectedSubItems);
    // Get lead_id, if any selectedItems has a lead_id field set to not null
    const lead_id = selectedItems?.find(
      (item) => item?.lead_id !== null
    )?.lead_id;
    const currentProjectSelectedItems = {
      project_id: props.settings?.project?.id,
      selected_items: selectedItemsForRedux?.filter((item) => item.id),
    };
    if (project_selected_items) {
      const indexOfProject = project_selected_items.findIndex(
        (element) => element?.project_id == props.settings?.project?.id
      );
      if (indexOfProject > -1) {
        project_selected_items[indexOfProject] = currentProjectSelectedItems;
      } else {
        project_selected_items.push(currentProjectSelectedItems);
      }
    } else {
      project_selected_items = [];
      project_selected_items.push(currentProjectSelectedItems);
    }
    dispatch({
      type: "settings/CHANGE_SETTING",
      payload: {
        setting: "selected_budget_items",
        value: {
          project_selected_items: project_selected_items,
          ...(lead_id && { project_selected_items_lead_id: lead_id }),
        },
      },
    });
    history(`/app/project/powo/new`);
  };

  function uploadData(e) {
    logger.log(LogEvents.bulkUploadItem, {});
    var items = e;
    const formValue = new FormData();
    formValue.append("project", props.settings.project.id);
    formValue.append("file", items, items.name);
    axios
      .post(`${BulkUploadItemApi}`, formValue)
      .then((res) => {
        toast.success("Items added successfully!");
        setModal1Visible(false);
        setModal3Visible(true);
        setVisible(false);
        setExcelData(res.data?.excel_data);
        fetchItems({ project: props.settings?.project?.id });
      })
      .catch((err) => {
        if (err?.response?.status === 500) {
          toast.error("Format does not match as what is required");
        }
      });
  }

  function uploadDataSubItem(e) {
    logger.log(LogEvents.bulkUploadSubItem, {});
    var items = e;
    const formValue = new FormData();
    formValue.append("item", itemId);
    formValue.append("file", items, items.name);
    axios
      .post(`${BulkUploadSubItemApi}`, formValue)
      .then((res) => {
        toast.success("Sub items added successfully!");
        setModal2Visible(false);
        setModal3Visible(true);
        setVisible(false);
        setExcelData(res.data?.excel_data);
        fetchItems({ project: props.settings?.project?.id });
      })
      .catch((res) => {
        toast.error(res.message);
      });
  }

  return (
    <>
      <div>
        <Card>
          <CardBody>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="d-flex align-items-center">
                <div className="h5 px-2">All Items</div>
                {selectedItems?.length > 0 && (
                  <>
                    <div className="px-1">
                      <Button
                        onClick={(e) => createPoWithSelectedItems()}
                        className="btn d-flex align-items-center justify-content-center border create-powo-btn"
                      >
                        <div
                          style={{
                            marginLeft: "4px",
                            paddingTop: "4px",
                            paddingBottom: "4px",
                          }}
                        >
                          Create PO/WO
                        </div>
                      </Button>
                    </div>
                    <div className="px-1">
                      <Button
                        onClick={(e) =>
                          deleteBudgetItems({
                            item_list: selectedItemsForDelete,
                            sub_item_list: selectedSubItemsForDelete,
                          }).then((res) => {
                            fetchItems({
                              project: props.settings?.project?.id,
                            });
                            // Clear out the selected items
                            setSelectedRowKeys([]);
                            setSelectedRowKeysSubItems([]);
                            setSelectedItems([]);
                            setSelectedSubItems([]);
                            setSelectedItemsForDelete([]);
                            setSelectedSubItemsForDelete([]);
                          })
                        }
                        className="btn d-flex align-items-center justify-content-center border delete-items-btn"
                      >
                        <div
                          style={{
                            marginLeft: "4px",
                            paddingTop: "4px",
                            paddingBottom: "4px",
                          }}
                        >
                          Delete Items
                        </div>
                      </Button>
                    </div>
                  </>
                )}
              </div>
              <Space>
                <Search placeholder="Search items" onSearch={onSearch} />

                <Button
                  onClick={(e) => {
                    logger.log(LogEvents.addBoqItem, {});
                    showDrawer();
                  }}
                  className="btn btn-primary d-flex align-items-center justify-content-center text-white"
                >
                  {" "}
                  <PlusCircle />
                  <div
                    style={{
                      marginLeft: "4px",
                      paddingTop: "4px",
                      paddingBottom: "4px",
                    }}
                  >
                    Add Item
                  </div>
                </Button>
                <Button
                  className="btn btn-primary"
                  onClick={() => {
                    handleDownload();
                    logger.log(LogEvents.downloadBudget, {});
                  }}
                >
                  <div style={{ color: "white" }}>Download Budget</div>
                </Button>
                <ColumnConfig
                  columns={userSelectedColumns}
                  setCols={(cols) => setUserSelectedColumns(cols)}
                  mode="budget"
                  onClick={() => {
                    logger.log(LogEvents.customizeBudgetMenu, {});
                  }}
                />
              </Space>
            </div>
            {console.log("selectedItems>>>", selectedItemsForDelete)}
            <div className="my-2">
              <Table
                loading={loading}
                dataSource={itemList}
                columns={getUserSelectedColumns()}
                pagination={{
                  position: ["bottomRight"],
                }}
                rowClassName={(record, index) =>
                  record.id === location.state?.item_id ? "table-row-color" : ""
                }
                rowSelection={rowSelection}
                scroll={{
                  x: "100%",
                  y: getTableHeight({ table_name: "budget_table" }),
                }}
                // expandable={{
                //   expandedRowRender,
                //   rowExpandable: (data) => data?.sub_items.length > 0,
                // }}
                rowKey="id"
                onRow={(record, rowIndex) => {
                  return {
                    onClick: (event) => {
                      if (selectedItems.find((item) => item.id === record.id)) {
                        setSelectedItems(
                          selectedItems.filter((item) => item.id !== record.id)
                        );
                        setSelectedRowKeys(
                          selectedRowKeys.filter((item) => item !== record.id)
                        );
                        setSelectedItemsForDelete(
                          selectedItemsForDelete.filter(
                            (item) => item !== record.id
                          )
                        );
                        return;
                      }

                      setSelectedItems([...selectedItems, record]);
                      setSelectedRowKeys([...selectedRowKeys, record?.id]);
                      setSelectedItemsForDelete([
                        ...selectedItemsForDelete,
                        record?.id,
                      ]);
                    },
                  };
                }}
              />
            </div>
          </CardBody>
        </Card>
      </div>
      <Drawer
        title={editId ? "Edit Item" : "Add Item"}
        width={500}
        onClose={() => {
          onClose();
        }}
        visible={visible}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          >
            <Button
              onClick={() => {
                onClose();
              }}
              style={{ marginRight: 8 }}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              form="vendorForm"
              type="primary"
              htmlType="submit"
            >
              Submit
            </Button>
          </div>
        }
      >
        <div className="px-3">
          <StyledDropzone setFile={uploadData} />
          <div className="my-2 text-center">
            <strong>
              <a
                href={
                  "https://material-depot-content-files.s3.ap-south-1.amazonaws.com/Mysite/Budget_Item_File.xlsx"
                }
                download
                onClick={() => {
                  logger.log(LogEvents.downloadBoqExample, {});
                }}
              >
                Download Example
              </a>
            </strong>
          </div>
        </div>
        <Form
          layout="vertical"
          id="vendorForm"
          ref={formRef}
          onFinish={AddItem}
          initialValues={{
            tax_type: "none",
            tax_value: 18,
          }}
        >
          <Row gutter={24}>
            <Col sm={24}>
              <Form.Item
                name={"boq_item"}
                label="BOQ Item"
                rules={[
                  {
                    required: true,
                    message: "BOQ Item is required",
                  },
                ]}
              >
                <Input size="large" placeholder="BOQ Item" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item name={"category_name"} label="Category">
                {/* <Select placeholder="Select Category">{categoryOptions}</Select> */}
                <Input size="large" placeholder="Category" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item name={"assigned_to"} label="Assigned to">
                <Select
                  key={itemAssignedTo}
                  size="large"
                  style={{
                    width: "100%",
                  }}
                  value={itemAssignedTo}
                  onChange={(e) => {
                    setItemAssignedTo(e);
                  }}
                  options={projectMembers}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={24}>
              <Form.Item name={"item_description"} label="Item Description">
                <TextArea rows={3} placeholder="Item Description" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item name={"unit"} label="Unit">
                <Input size="large" placeholder="Unit" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name={"quantity"}
                label="Quantity"
                rules={[
                  {
                    required: true,
                    message: "Quantity is required",
                  },
                ]}
              >
                <InputNumber
                  className="w-100"
                  size="large"
                  placeholder="Quantity"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item name={"brand"} label="Brand">
                <Input size="large" placeholder="Brand" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name={"budget_price"}
                label="Target Price"
                rules={[
                  {
                    required: true,

                    message: "Target Price is required",
                  },
                ]}
              >
                <InputNumber
                  className="w-100"
                  size="large"
                  placeholder="Target Price"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name={"boq_price"}
                label="Boq Price"
                rules={[
                  {
                    required: true,
                    message: "Sales Price is required",
                  },
                ]}
              >
                <InputNumber
                  className="w-100"
                  size="large"
                  placeholder="Boq Price"
                />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item name={"tax_value"} label="Tax">
                <Select
                  size="large"
                  className="w-100"
                  placeholder="Select tax value"
                >
                  {[0, 5, 12, 18, 28]?.map((each, index) => (
                    <Option key={index} value={each}>
                      {each}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {/* <Col sm={12}>
              <Form.Item name={"tax_type"} label="Tax">
                <Select
                  size="large"
                  className="w-100"
                  placeholder="Select tax type"
                >
                  {taxTypes?.map((each) => (
                    <Option key={each?.id} value={each?.value}>
                      {each?.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col> */}
            <Col sm={12}>
              <Form.Item
                name={"timeline"}
                label="Timeline"
                valuePropName={date}
              >
                <DatePicker
                  size="large"
                  key={date}
                  allowClear={false}
                  format="YYYY-MM-DD"
                  value={moment(date ?? new Date(), "YYYY-MM-DD")}
                  onChange={(e) => {
                    setDate(moment(e)?.format("YYYY-MM-DD"));
                  }}
                  className="w-100"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col sm={24}>
              <Form.Item name={"remark"} label="Remarks">
                <TextArea rows={4} placeholder="Remarks" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
      <Drawer
        title={editIdSub ? "Edit Sub Item" : "Add Sub Item"}
        width={500}
        onClose={() => {
          onCloseSub();
        }}
        visible={visibleSub}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          >
            <Button
              onClick={() => {
                onCloseSub();
              }}
              style={{ marginRight: 8 }}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              form="subItemForm"
              type="primary"
              htmlType="submit"
            >
              Submit
            </Button>
          </div>
        }
      >
        <div className="px-3">
          <StyledDropzone setFile={uploadDataSubItem} />
          <div className="my-2 text-center">
            <strong>
              <a
                href="https://material-depot-content-files.s3.ap-south-1.amazonaws.com/Mysite/Budget_Item_File.xlsx"
                download
              >
                Download Example
              </a>
            </strong>
          </div>
        </div>
        <Form
          layout="vertical"
          id="subItemForm"
          ref={subItemRef}
          onFinish={AddSubItem}
          initialValues={{
            tax_type: "none",
            tax_value: 18,
          }}
        >
          <Row gutter={24}>
            <Col sm={24}>
              <Form.Item
                name={"boq_sub_item"}
                label="BOQ Sub Item"
                rules={[
                  {
                    required: true,
                    message: "BOQ Sub Item is required",
                  },
                ]}
              >
                <Input size="large" placeholder="BOQ Item" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item name={"category_name"} label="Category name">
                <Input size="large" placeholder="Category name" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item name={"assigned_to"} label="Assigned to">
                <Select
                  key={itemAssignedTo}
                  size="large"
                  style={{
                    width: "100%",
                  }}
                  value={itemAssignedTo}
                  onChange={(e) => {
                    setItemAssignedTo(e);
                  }}
                  options={projectMembers}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={24}>
              <Form.Item name={"item_description"} label="Item Description">
                <TextArea rows={3} placeholder="Item Description" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item name={"unit"} label="Unit">
                <Input size="large" placeholder="Unit" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name={"quantity"}
                label="Quantity"
                rules={[
                  {
                    required: true,
                    message: "Quantity is required",
                  },
                ]}
              >
                <InputNumber
                  className="w-100"
                  size="large"
                  placeholder="Quantity"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name={"boq_price"}
                label="Sales Price"
                rules={[
                  {
                    required: true,
                    message: "Sales Price is required",
                  },
                ]}
              >
                <InputNumber
                  className="w-100"
                  size="large"
                  placeholder="Sales Price"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item name={"brand"} label="Brand">
                <Input size="large" placeholder="Brand" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name={"budget_price"}
                label="Target Price"
                rules={[
                  {
                    required: true,
                    message: "Target Price is required",
                  },
                ]}
              >
                <InputNumber
                  className="w-100"
                  size="large"
                  placeholder="Target Price"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item name={"tax_value"} label="Tax">
                <Select
                  size="large"
                  className="w-100"
                  placeholder="Select tax value"
                >
                  {[0, 5, 12, 18, 28]?.map((each, index) => (
                    <Option key={index} value={each}>
                      {each}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {/* <Col sm={12}>
              <Form.Item name={"tax_type"} label="Tax">
                <Select
                  size="large"
                  className="w-100"
                  placeholder="Select tax type"
                >
                  {taxTypes?.map((each) => (
                    <Option key={each?.id} value={each?.value}>
                      {each?.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col> */}
          </Row>
        </Form>
      </Drawer>

      <Drawer
        title={"PO Details"}
        width={800}
        onClose={() => {
          setPoDetailsDrawerVisible(false);
        }}
        visible={poDetailsDrawerVisible}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          >
            {/* <Button
              onClick={() => {
                onCloseSub();
              }}
              style={{ marginRight: 8 }}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              form="subItemForm"
              type="primary"
              htmlType="submit"
            >
              Submit
            </Button> */}
          </div>
        }
      >
        {poDetailsOfItem?.map((detail) => {
          return (
            <Card>
              <CardBody>
                <Row>
                  <Col sm={12} style={{ margin: "auto" }}>
                    <Col sm={24}>
                      <Row>
                        <Col
                          sm={12}
                          className=""
                          style={{
                            fontSize: "12px",
                            color: "#928d8d",
                            fontWeight: "500",
                            marginBottom: "-8px",
                            margin: "auto",
                          }}
                        >
                          PO Number{" "}
                        </Col>
                        <Col
                          sm={12}
                          className="text-right fw-bold"
                          style={{ fontSize: "22px" }}
                        >
                          {detail?.po__po_number}
                        </Col>
                      </Row>
                    </Col>
                    <Col
                      sm={24}
                      style={{
                        fontSize: "14px",
                        color: "#928d8d",
                        fontWeight: "500",
                      }}
                    >
                      Created by{" "}
                      <span className="fw-bold" style={{ color: "#000" }}>
                        {" "}
                        {detail?.po__created_by__name}{" "}
                      </span>
                    </Col>{" "}
                    <Col
                      sm={12}
                      style={{
                        fontSize: "14px",
                        color: "#928d8d",
                        fontWeight: "500",
                      }}
                    >
                      Vendor:{" "}
                      <span className="fw-bold" style={{ color: "#000" }}>
                        {" "}
                        {detail?.po__vendor__name}
                      </span>
                    </Col>{" "}
                    <Col sm={20}>
                      <Button
                        onClick={(e) => {
                          history("/app/project/po-details/" + detail.po);
                        }}
                        type="primary"
                        className="btn d-flex align-items-center justify-content-center border go-to-po-btn"
                      >
                        <div
                          style={{
                            marginLeft: "4px",
                            paddingTop: "4px",
                            paddingBottom: "4px",
                          }}
                        >
                          See Po
                        </div>
                      </Button>
                    </Col>
                  </Col>
                  <Col sm={12}>
                    <Row className="px-2">
                      <Col sm={12} className="" style={{ color: "#928d8d" }}>
                        Quantity:{" "}
                      </Col>
                      <Col sm={12} className="text-right">
                        {detail?.quantity}
                      </Col>
                    </Row>
                    <Row className="px-2">
                      <Col sm={12} className="" style={{ color: "#928d8d" }}>
                        Discount:{" "}
                      </Col>
                      <Col sm={12} className="text-right">
                        {detail?.discount}%
                      </Col>
                    </Row>
                    <Row className="px-2">
                      <Col sm={12} className="" style={{ color: "#928d8d" }}>
                        Tax:
                      </Col>

                      <Col sm={12} className="text-right">
                        {detail?.tax_value}%{" "}
                        {detail?.tax_type == "igst" ? "IGST" : ""}
                        {detail?.tax_type == "cgst_sgst" ? "CGST & SGST" : ""}
                        {detail?.tax_type == "none" ? "None" : ""}
                      </Col>
                    </Row>
                    <Row className="px-2">
                      <Col sm={12} className="" style={{ color: "#928d8d" }}>
                        PO price:{" "}
                      </Col>
                      <Col sm={12} className="text-right">
                        {"₹"}
                        {detail?.unit_po_price}
                      </Col>
                    </Row>
                    <Row className="px-2">
                      <Col sm={12} className="" style={{ color: "#928d8d" }}>
                        Total price:{" "}
                      </Col>
                      <Col sm={12} className="text-right">
                        {detail?.quantity} {"×"} {"₹"}
                        {detail?.unit_po_price}
                      </Col>
                    </Row>

                    <Row
                      style={{
                        background: "#f2f2f2",
                        padding: "2px 10px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Col sm={12} className="" style={{ fontSize: "12px" }}>
                        Inclusive of all taxes{" "}
                      </Col>
                      <Col
                        sm={12}
                        className="text-right fw-bold"
                        style={{ fontSize: "25px" }}
                      >
                        {"₹"}
                        {detail?.total_price}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          );
        })}
        {poDetailsOfItem?.length == 0 && (
          <Card>
            <CardBody>No Po Raised for this Item</CardBody>
          </Card>
        )}
      </Drawer>
      <Modal
        title="Add Bulk Items"
        centered
        visible={modal1Visible}
        onCancel={() => {
          setModal1Visible(false);
        }}
        footer={null}
      >
        <div className="px-3">
          <StyledDropzone setFile={uploadData} />
          <div className="my-2 text-center">
            <strong>
              <a
                href={
                  "https://material-depot-content-files.s3.ap-south-1.amazonaws.com/Mysite/Budget_Item_File.xlsx"
                }
                download
              >
                Download Example
              </a>
            </strong>
          </div>
        </div>
      </Modal>
      <Modal
        title="Add Bulk Sub Items"
        centered
        visible={modal2Visible}
        width="600px"
        onCancel={() => {
          setModal2Visible(false);
          setItemId(null);
        }}
        footer={null}
      >
        <div className="px-3">
          <StyledDropzone setFile={uploadDataSubItem} />
          <div className="my-2 text-center">
            <strong>
              <a
                href="https://material-depot-content-files.s3.ap-south-1.amazonaws.com/Mysite/Budget_Item_File.xlsx"
                download
              >
                Download Example
              </a>
            </strong>
          </div>
        </div>
      </Modal>
      <Modal
        title="Bulk Upload Result"
        centered
        visible={modal3Visible}
        width="600px"
        onCancel={() => {
          setModal3Visible(false);
        }}
        footer={null}
      >
        <UploadResultTable data={excelData} />
      </Modal>
    </>
  );
};

export default connect(mapStateToProps)(Budget);
